<div class="container">
    <div class="menu">
        <tam-wizard-menu [config]="wizardConfig"></tam-wizard-menu>
    </div>
    <div class="content">
        <div class="header">
            <span class="text-ellipsis">
                {{wizardConfig.config.menuData[wizardConfig.config.active].title}}
            </span>
        </div>
        <div class="body">
            <div class="panel">
                <div class='panel-item' *ngIf="wizardConfig.config.active===0">
                    <task-definition [config]="config" [needValidControl]="taskDefinitionNeedValidControl">
                    </task-definition>
                </div>
                <div class='panel-item'
                    *ngIf="wizardConfig.config.menuData[wizardConfig.config.active].id==='form-builder'">
                    <tam-template-configuration [config]="templateConfig">
                    </tam-template-configuration>
                </div>
                <div class='panel-item' *ngIf="wizardConfig.config.active===(wizardConfig.config.menuData.length-1)">
                    <task-post-action [config]="config" [otherConfig]="postActionConfig"></task-post-action>
                </div>
            </div>
            <div class="footer">
                <button class="btn btn-primary" tam-button [tamType]="'tertiary'" (click)="onCancel()">Cancel</button>
                <button class="btn btn-primary" tam-button [tamType]="'primary'" (click)="onSave()">Save</button>
            </div>
        </div>
    </div>
</div>